<template>
  <section class="about-card-designs">
    <div class="about-card-designs__content">
      <AboutPageHeadline
        title="キモチが伝わるカードデザイン"
        :sub-title="`豊富なカードデザインからシーンに合ったものを\n選んで、ギフトと一緒に贈れます`"
      />
      <div class="about-card-designs__card-design-categories">
        <div class="about-card-designs__card-design-category">
          <h3 class="about-card-designs__head">ありがとう</h3>
          <div class="about-card-designs__cards">
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="ThanksCardDesign1"
                alt-text="ありがとう カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="ThanksCardDesign2"
                alt-text="ありがとう カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="ThanksCardDesign3"
                alt-text="内祝い カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
          </div>
        </div>
        <div class="about-card-designs__card-design-category">
          <h3 class="about-card-designs__head">おめでとう</h3>
          <div class="about-card-designs__cards">
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="CongratulationsCardDesign1"
                alt-text="誕生日 カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="CongratulationsCardDesign2"
                alt-text="結婚祝い カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="CongratulationsCardDesign3"
                alt-text="出産祝い カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
          </div>
        </div>
        <div class="about-card-designs__card-design-category">
          <h3 class="about-card-designs__head">おつかれさま</h3>
          <div class="about-card-designs__cards">
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="GoodjobCardDesign1"
                alt-text="差し入れ カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="GoodjobCardDesign2"
                alt-text="おつかれさま カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="GoodjobCardDesign3"
                alt-text="おつかれさま カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
          </div>
        </div>
        <div class="about-card-designs__card-design-category">
          <h3 class="about-card-designs__head">季節のあいさつ</h3>
          <div class="about-card-designs__cards">
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="SeasonCardDesign1"
                alt-text="春 カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="SeasonCardDesign2"
                alt-text="夏 カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
            <div class="about-card-designs__card">
              <ImgLazy
                :image-url="SeasonCardDesign3"
                alt-text="クリスマス カードデザイン"
                aspect-ratio="1 / 1"
              />
            </div>
          </div>
        </div>
      </div>
      <AboutPageSeeMoreButton
        text="カードデザインを選ぶ"
        href="/card_designs"
      />
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import AboutPageHeadline from '../../../atoms/headlines/AboutPageHeadline.vue'
import AboutPageSeeMoreButton from '../../../molecules/buttons/AboutPageSeeMoreButton.vue'
import ThanksCardDesign1 from '../../../../../../images/abouts/card_designs/01_thanks/01_297.jpg'
import ThanksCardDesign2 from '../../../../../../images/abouts/card_designs/01_thanks/02_454.jpg'
import ThanksCardDesign3 from '../../../../../../images/abouts/card_designs/01_thanks/03_390.jpg'
import CongratulationsCardDesign1 from '../../../../../../images/abouts/card_designs/02_congratulations/01_130.jpg'
import CongratulationsCardDesign2 from '../../../../../../images/abouts/card_designs/02_congratulations/02_452.gif'
import CongratulationsCardDesign3 from '../../../../../../images/abouts/card_designs/02_congratulations/03_289.jpg'
import GoodjobCardDesign1 from '../../../../../../images/abouts/card_designs/03_goodjob/01_223.jpg'
import GoodjobCardDesign2 from '../../../../../../images/abouts/card_designs/03_goodjob/02_397.jpg'
import GoodjobCardDesign3 from '../../../../../../images/abouts/card_designs/03_goodjob/03_138.jpg'
import SeasonCardDesign1 from '../../../../../../images/abouts/card_designs/04_season/01_276.jpg'
import SeasonCardDesign2 from '../../../../../../images/abouts/card_designs/04_season/02_298.jpg'
import SeasonCardDesign3 from '../../../../../../images/abouts/card_designs/04_season/03_470.jpg'
</script>

<style lang="scss" scoped>
.about-card-designs {
  background-color: $gray-3;
  display: flex;
  justify-content: center;

  &__content {
    padding: 96px 72px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    max-width: 1440px;
    width: 100%;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 64px 24px;
      gap: 24px;
    }
  }

  &__card-design-categories {
    margin: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;

    @media all and (max-width: ($base-contents-width - 1)) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &__card-design-category {
    background-color: $white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 32px;
    padding: 32px;
    gap: 24px;

    @media all and (max-width: ($pc-width  - 1)) {
      padding: 24px;
    }
  }

  &__head {
    font-weight: bold;
    font-size: 1.8rem;
    line-height: 1.6;
    color: $primary;
  }

  &__cards {
    display: flex;
    gap: 16px;
  }

  &__card {
    overflow: hidden;
    width: 100%;

    img {
      width: 100%;
    }
  }
}

:deep(.about-page-headline__title) {
  @media all and (max-width: ($pc-width - 1)) {
    font-size: 2.4rem;
  }
}
</style>
